// extracted by mini-css-extract-plugin
module.exports = {"stats":"CaseStudyStats_stats__Xx5jz","stat":"CaseStudyStats_stat__iZNRc","value":"CaseStudyStats_value__ozbll","label":"CaseStudyStats_label__hmnna"};